import CryptoJS from 'crypto-js';
import JSEncrypt from 'jsencrypt';

import { credentialsKey } from '../resources/environmentConstants';

/**
 * @param {String} text Text to encrypt
 * @returns {String} Encrypted text
 */
export const encrypt = (text) => {
  const key = CryptoJS.enc.Utf8.parse(credentialsKey);
  const iv = CryptoJS.enc.Utf8.parse(credentialsKey);

  const encryptedpassword = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(text), key, {
    keySize: 128 / 8,
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  return encryptedpassword.toString();
};

/**
 * Formatea una clave pública en formato PEM, añadiendo los saltos de línea y encabezados.
 * @param {string} rawKey The raw public key.
 * @returns {string} La clave en formato PEM.
 */
export const formatPublicKey = (rawKey) => {
  // Ensure the key has no whitespace
  const keyWithoutWhitespace = rawKey.trim();

  // Split the key into 64-character blocks and add line breaks
  let formattedKey = '';

  for (let i = 0; i < keyWithoutWhitespace.length; i += 64) {
    formattedKey += `${keyWithoutWhitespace.substring(i, i + 64)}\n`;
  }

  // Add the PEM format headers and footers
  return `-----BEGIN PUBLIC KEY-----\n${formattedKey}-----END PUBLIC KEY-----`;
};

export const encryptWithRSA = (text) => {
  const credentialsKeyPublic =
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAqRKCyJAZpWyKr7ro12ZqBMgW18UZlK7jv+EVBloPlaxWSmB4ITXj7/u5ZoZclJzNqVQ2OU+4R4QfuPDZPn5uTeRRzJoK46o6DUP792R3CVfuZdWPzLMUMwTPR4YoL9rU7YVY9g54G2n/gooh3BmNoYAG0tu59/6q27fSe9Twl2IUCff0QLAn1peOiVwsrQLnzxWtOelcTDh7nQe+9qn4h5HGGKmFxqzna2y0u8p8qMIWDa87Qc9YxVzzAcMZDDCtUp5Jpa+hZaj2WOPDY3A2EJqKlsh7KjSR8OC+O899DJ1HPiFu+pqUDeH3cJhwZ4vLRvsFrdjK5jGCw6VqD2NEtQIDAQAB';
  const crypt = new JSEncrypt({ default_key_size: 2048 });
  const publicKey = formatPublicKey(credentialsKeyPublic);

  crypt.setPublicKey(publicKey);
  const encriptedText = crypt.encrypt(text);

  return encriptedText || '';
};
